/**
 * Hidden troubleshoot gate.
 *
 * The troubleshoot UI is visible ONLY when the URL contains both
 * `who=seanmehrabi` (hardcoded developer handle) and
 * `troubleshoot=1` (or `troubleshoot=true`, or the common typo
 * `trobleshoot`). Append these query params to any route. This is a
 * deliberate hardcode — the portal developer uses it to demo
 * diagnostics without exposing them to normal end users.
 *
 * Usage:
 *   https://portal.example.com/myapps/profile?who=seanmehrabi&troubleshoot=1
 */

const TROUBLESHOOT_WHO = "seanmehrabi";

export function isTroubleshootMode(search: string | URLSearchParams): boolean {
  const params =
    typeof search === "string" ? new URLSearchParams(search) : search;
  const who = (params.get("who") ?? "").trim().toLowerCase();
  const flag = (
    params.get("troubleshoot") ??
    params.get("trobleshoot") ??
    ""
  ).trim();
  return who === TROUBLESHOOT_WHO && (flag === "1" || flag.toLowerCase() === "true");
}

export const TROUBLESHOOT_HANDLE = TROUBLESHOOT_WHO;
